<template>
  <div class="page-layout">
    <div class="page-content page-content--narrow">
      <h1>Контакты</h1>
      <div class="panel">
        <p>По всем вопросам обращайтесь по email: <a href="mailto:iam@multed.com">iam@multed.com</a></p>
        <p>Разработка: Евгений Лисовский</p>
      </div>
    </div>
  </div>
</template>
